export interface PrioritasiRisikoDepartemenDataModel {
  ulid: string;
  name: string;
  description: string;
  status: string;
  rcsa: any;
  total_skor: number;
  nilai: number;
  nilai_prioritasi: any[];
  properties: any
}

export interface AgregasiRisikoDataModel {
  ulid: string;
  nomor: number; // Automatic numeric value
  id_risiko_agregat: string; // Auto-generated string
  risiko_agregat: string; // Free text
  id_risiko_peluang?: string[]; // Array for multiple selected values
  risiko_departemen: any[];
}

export interface PrioritisasiAgregasiRisiko {
  ulid: string;
  total_skor: string;
  id_user: number;
  created_at: string;
  updated_at: string;
  nilai_prioritasi_agregat: any[];
  user: any;
}

export interface NilaiPrioritasiAgregat {
  id: number;
  prioritasi_agregasi_risiko_id: number;
  kriteria_prioritasi_id: number;
  nilai: string;
  created_at: string;
  updated_at: string;
  kriteria_prioritasi: any;
  ulid: string;
}

export interface PrioritasAgregat {
  id_risiko_agregat: string;
  ulid_risiko_agregat: string;
  total_skor: number;
  risiko_agregat: string;
  nilai_prioritasi_agregat: NilaiPrioritasiAgregat[];
}

export interface PrioritasiRisikoAgregatDataModel {
  id_user: string;
  penilai: string | null;
  prioritasAgregat: PrioritasAgregat[];
}

export interface PenetapanRisikoUtamaDataModel {
  nomor: number;
  id_risiko_agregat: string;
  resiko_agregat: string;
  penilai: string;
  agregasi_risiko: any;
  kriteriaPenetapan: string;
  skorRisiko: number;
  total_skor: number;
  is_risiko_utama: Boolean;
  id_risiko_utama: string;
  ulid: string;
  status: string;
  penanganan_risiko: any;
  average_prioritasi_departemen: number;
  analisis_risiko: AnalisisRisiko;
  identifikasi_risiko: any[];
  evaluasi_risiko: any;
}

export interface AnalisisRisiko {
  id: number;
  ulid: string;
  code: any;
  id_risiko_utama: number;
  parameter_dampak_inherent: number;
  deskripsi_dampak_inherent: number;
  dampak_inherent: number;
  parameter_kemungkinan_inherent: number;
  deskripsi_kemungkinan_inherent: number;
  kemungkinan_inherent: number;
  tingkat_risiko_inherent: number;
  created_at: string;
  updated_at: string;
}

export interface IndikatorRisikoUtamaDataModel {
  id: number;
  code: string;
  ulid: string;
  id_risiko_utama: number;
  identifikasi_risiko: any[];
  indikator_risiko_utama: string;
  formula: string;
  unit: string;
  created_at: string;
  updated_at: string;
  deskripsi_treshold: Deskripsitershold[];
  dampak_inherent: number;
  kemungkinan_inherent: number;
  tingkat_risiko_inherent: number;
  rencana_mitigasi_risiko: string;
  dampak_target: number;
  kemungkinan_target: number;
  tingkat_risiko_target: number;
}
export interface Deskripsitershold {
  value: string;
  priority: number;
  kri_treshold?: any;
}

export interface KRIModel {
  prioritasiRisikoDepartemen: {
    data: PrioritasiRisikoDepartemenDataModel[];
    total: number;
    can_approval: boolean;
  };
  agregasiRisiko: {
    data: AgregasiRisikoDataModel[];
    total: number;
  };
  detailAgregasi: any;
  prioritasiRisikoAgregat: {
    data: PrioritasiRisikoAgregatDataModel;
    total: number;
  };
  penetapanRisikoUtama: {
    data: PenetapanRisikoUtamaDataModel[];
    total: number;
  };
  detailAmbangKRI: any;
  registerIRU: {
    data: IndikatorRisikoUtamaDataModel[];
    total: number;
  };
  detailRegisterIRU: any;
}

export enum KRIActionType {
  GetPrioritasiRisikoDepartemen = "Parameter Setting/KRI/GetPrioritasiRisikoDepartemen",
  GetAgregasiRisiko = "Parameter Setting/KRI/GetAgregasiRisiko",
  GetDetailAgregasiRisiko = "Parameter Setting/KRI/GetDetailAgregasiRisiko",
  GetPrioritasiRisikoAgregat = "Parameter Setting/KRI/GetPrioritasiRisikoAgregat",
  GetPenetapanRisikoUtama = "Parameter Setting/KRI/GetPenetapanRisikoUtama",
  GetAmbangKRI = "Parameter Setting/KRI/GetAmbangKRI",
  GetRegisterIRU = "Parameter Setting/KRI/GetRegisterIRU",
  GetDetailRegisterIRU = "Parameter Setting/KRI/GetDetailRegisterIRU",
}

export type KRIAction =
  | {
      type: KRIActionType.GetPrioritasiRisikoDepartemen;
      data: {
        data: PrioritasiRisikoDepartemenDataModel[];
        total: number;
        can_approval: boolean;
      };
    }
  | {
      type: KRIActionType.GetAgregasiRisiko;
      data: {
        data: AgregasiRisikoDataModel[];
        total: number;
      };
    }
  | {
      type: KRIActionType.GetDetailAgregasiRisiko;
      data: any;
    }
  | {
      type: KRIActionType.GetPrioritasiRisikoAgregat;
      data: {
        data: PrioritasiRisikoAgregatDataModel;
        total: number;
      };
    }
  | {
      type: KRIActionType.GetPenetapanRisikoUtama;
      data: {
        data: PenetapanRisikoUtamaDataModel[];
        total: number;
      };
    }
  | {
      type: KRIActionType.GetAmbangKRI;
      data: {
        data: any;
        total: number;
      };
    }
  | {
      type: KRIActionType.GetRegisterIRU;
      data: {
        data: any;
        total: number;
      };
    }
  | {
      type: KRIActionType.GetDetailRegisterIRU;
      data: {
        data: any;
      };
    };
